import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { navSelector } from '../../../../../store/js/modules/video-hub/nav/selectors/nav-selector';

export const useMatchesData = () => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const data = useSelector(
        (state) =>
            PULSE.app.redux.selectors.matchList.item(
                state,
                nav.competition?.id,
                nav.season?.id,
                nav.round
            ) ?? []
    );

    // Fetch matches
    useEffect(() => {
        if (!data.length && nav.competition?.id && nav.season?.id) {
            dispatch(
                PULSE.app.redux.actions.matchList.FETCH_MATCHLIST_DATA.request({
                    competitionId: nav.competition?.id,
                    seasonId: nav.season?.id,
                    roundNumber: nav.round
                })
            );
        }
    }, [dispatch, data.length, nav.competition?.id, nav.season?.id, nav.round]);

    return data;
};
